module.exports = __webpack_public_path__ + "img/bg_4.002d5586.png";